module.exports = __webpack_public_path__ + "img/orange-pickup-bg@2x.b0d3538c.png";